import APP_SETTINGS from '../appSettings';
import firebase from 'firebase/app';

export function initializeSecondaryFirebaseApp(devMode) {
  try {
    return firebase.app('secondary');
  } catch {
    return firebase.initializeApp(devMode ? APP_SETTINGS.FIREBASE_NEW_CONFIG : APP_SETTINGS.FIREBASE_PRODUCTION, 'secondary');
  }
}